<template>
    <div class="header-container">
        <div class="header">
            <a :href="DOMAIN">
                <img alt="" class="logo_zc" :src="user.morgwlogo" v-if="user.morgwlogo"/>
                <img alt="" class="logo_zc" src="../../../assets/img/logo.png" v-else/>
            </a>
            <div class="home flex align-center">
                <div class="service text-white margin-right-sm">
                    <i class="iconfont icon-kefu margin-right-xs text-xs"></i>客服电话：{{ service_phone }}
                </div>
                <div class="header-operate flex flex-direction align-center justify-center">
                    <div class="flex align-center">
                        <i class="icon iconfont icon-hezuo"></i>
<!--                        <div class="label">佳佳</div>-->
                    </div>
                    <div class="label">合作咨询</div>
                    <div class="wx-mini-container flex flex-direction justify-center align-center">
                        <img class="image" src="../../../assets/img/erweima_kf_jj.png"/>
                        <div class="tips text-center">刘老师 13051052979 (微信同号)</div>
                    </div>
                </div>
                <div class="header-operate flex flex-direction align-center justify-center">
                    <div class="flex align-center">
                        <i class="icon iconfont icon-tousujianyi"></i>
<!--                        <div class="label">任老师</div>-->
                    </div>
                    <div class="label">投诉建议</div>
                    <div class="wx-mini-container flex flex-direction justify-center align-center">
                        <img class="image" src="../../../assets/img/erweima_kf_rz.png"/>
                        <div class="tips text-center">任老师 13121702211 (微信同号)</div>
                    </div>
                </div>
                <router-link class="header-operate flex flex-direction align-center justify-center" to="/web/help">
                    <i class="icon iconfont icon-bangzhuzhongxin"></i>
                    <div class="label">帮助中心</div>
                </router-link>
                <div class="header-operate flex flex-direction align-center justify-center" @click="logout">
                    <i class="icon iconfont icon-logout"></i>
                    <div class="label">退出登录</div>
                </div>
                <el-link class="header-operate yellow" :href="DOMAIN" :underline="false" target="_blank">
                    <div class="label">访问首页</div>
                </el-link>

            </div>
        </div>
    </div>
</template>

<script>
import {service_phone, web_zc_home} from "@/utils/const";
import {userLogout} from "@/utils/utils";
import {DOMAIN} from "@/config";

export default {
    components: {},
    name: "HeaderMenuModular",
    data() {

        return {
            service_phone: service_phone,
            web_zc_home: web_zc_home,
            DOMAIN: DOMAIN
        }
    },
    props: {},
    computed: {
        user() {
            return this.$store.state.user
        },
        emofUserTokenSafer() {
            return this.$store.state.emofUserTokenSafer
        }
    },
    created() {

    },
    methods: {
        logout() {
            userLogout()
        }
    }
}
</script>

<style lang="scss" scoped>
.header-container {
    background-color: #0a2240;
    box-shadow: 0 6px 18px 1px rgba(10, 34, 64, 0.45);
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100px;
        margin: 0 30px;
        .logo_zc {
            height: 46px;
        }

        .logo {
            margin: 20px 0;
            height: 59px;
            width: 59px;
            border-radius: 59px;
        }

        > .title {
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            margin-left: 20px;
        }

        .home {

            .operate {
                padding: 0 20px;
                height: 40px;
                background-color: var(--orange);
                border-radius: 20px;
                font-size: 16px;
                color: #ffffff;
                line-height: 40px;
                text-align: center;
                cursor: pointer;
                user-select: none;

                &.white {
                    background-color: transparent;
                    border: 1px solid #FFFFFF;
                }
            }

            .operate + .operate {
                margin-left: 20px;
            }

            .to-link {
                width: 150px;
                height: 41px;
                padding: 3px;
                cursor: pointer;
                background-image: linear-gradient(
                        37deg, #ffb400, #fc7802), linear-gradient(#ff9600, #ff9600);
                background-blend-mode: normal, normal;
                border-radius: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-left: 10px;

                .title {
                    font-size: 14px;
                    font-weight: 700;
                    line-height: 17px;
                    color: #fff;
                    text-align: center;
                }

                .tips {
                    font-size: 12px;
                    line-height: 18px;
                    text-align: center;
                    color: #021e3f;
                }
            }
        }

    }
}
</style>